import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { fetchServices } from '../../../../../actions/services-api';
import { PensionDetails } from './pensionDetails';
import { ConnectionTypes } from '../../../../../constants/utils/connectionTypes';

export const Pension = ({ generateRelocationLetters }) => {
	const dispatch = useDispatch();
	const [pensionState, setPensionState] = useState({
		items: [],
		services: [],
	});
	const services = useSelector((state) => state.services);
	const user = useSelector((state) => state.user);

	const activityVector = services.serviceData["Pension"];
	useEffect(() => {
		let isMounted = true;
		
		const fetchData = async () => {
			if (R.isEmpty(pensionState.services)) {
				let elements = await dispatch(fetchServices(ConnectionTypes.pension));
				if (isMounted) {
					setPensionState({ ...pensionState, items: [...pensionState.items], services: pensionState.services.concat(elements.items) });
				}
			}
		};
		
		fetchData();
		
		return () => {
			isMounted = false;
		};
	}, [pensionState]);
	useEffect(() => {
		let pensionsInState = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[ConnectionTypes.pension]) ? services.serviceData[ConnectionTypes.pension] : [];
		if (pensionsInState.length > 0) {
			setPensionState({
				...pensionState,
				items: pensionsInState,
			});
		} else {
			setPensionState({ ...pensionState, items: pensionState.items.concat({}) });
		}
	}, [services.serviceData, activityVector]);

	function removePension(pension) {
		setPensionState({ ...pensionState, items: pensionState.items.filter((a) => a !== pension) });
	}

	if (R.isEmpty(pensionState.services)) {
		return "";
	}

	return (
		<article className="block" id="activité">
			<h3 className="sr-only visually-hidden">Retraite</h3>
			{pensionState.items.map((item, index) => {
				return <PensionDetails key={index} index={index} user={user} pension={item} removePension={removePension} services={pensionState.services} generateRelocationLetters={generateRelocationLetters} />;
			})}

			<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
				<h4 className="sr-only visually-hidden">Ajouter une autre RETRAITE</h4>
				<button
					type="button"
					className="btn btn-icon btn-alert-info mx-auto py-2"
					onClick={(e) => {
						const nodes = window.document.querySelectorAll(".collapse.show");
						if (!R.isNil(nodes) && nodes.length > 0) {
							nodes.forEach((element) => {
								element.classList.remove(["show"]);
							});
						}
						setPensionState({ ...pensionState, items: pensionState.items.concat({}) });
					}}>
					<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter une autre RETRAITE
				</button>
			</footer>
		</article>
	);
};